var _rect, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginRightImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 312,
    viewBox: "0 0 508 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    width: 432,
    height: 240,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D5DAE5",
    strokeLinecap: "round",
    d: "M56.5 43h391M56.5 81.1h391M56.5 116.7h391M56.5 152.3h391M56.5 187.9h391M56.5 223.5h391"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.884 106.122 56 109.031V206h392V73.687l-8.329 4.833h-8.883l-4.165 4.525h-5.552c-1.481.754-4.553 2.262-4.997 2.262-.445 0-3.332.905-4.72 1.358l-11.938 1.357-6.94 1.81-11.105-1.81-5.83-1.357-8.329 3.167h-8.606l-7.218-3.167c-2.776-.453-8.44-1.358-8.884-1.358-.444 0-4.072-.905-5.83-1.357h-4.442l-10.549 1.357-9.162 1.358-4.164 3.167-12.493 1.358-6.385 1.357-7.218 2.263-6.941 5.429h-3.054l-8.328-1.357-8.051-4.073-6.941-2.262h-4.164l-7.218-1.357-10.272 1.357h-9.717l-9.717 2.263-9.716 2.714-7.218 2.715-7.774 1.358-10.549-1.358-8.329 1.358-8.329 1.357-7.773-1.357-10.55 3.167-8.883-1.81-8.884 1.81h-8.607l-9.161 1.358h-9.44l-9.438 1.357-9.162-2.715-9.161 1.358z",
    fill: "url(#b)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56 109.031 8.884-2.909 9.161-1.358 9.162 2.715 9.439-1.357h9.439l9.161-1.358h8.607l8.884-1.81 8.883 1.81 10.55-3.167 7.773 1.357 8.329-1.357 8.329-1.358 10.549 1.358 7.774-1.358 7.218-2.715 9.716-2.715 9.717-2.262h9.717l10.272-1.357 7.218 1.357h4.164l6.941 2.263 8.051 4.072 8.328 1.357h3.054l6.941-5.43 7.218-2.262 6.385-1.357 12.493-1.358 4.164-3.167 9.162-1.358 10.549-1.357h4.442c1.758.452 5.386 1.357 5.83 1.357.444 0 6.108.905 8.884 1.358l7.218 3.167h8.606l8.329-3.167 5.83 1.357 11.105 1.81 6.94-1.81 11.938-1.357c1.388-.453 4.275-1.358 4.72-1.358.444 0 3.516-1.508 4.997-2.262h5.552l4.165-4.525h8.883L448 73.688M56 144.232l8.884-1.853 9.161-.865 9.162 1.73 9.439-.865h9.439l9.161-.865h8.607l8.884-1.153 8.883 1.153 10.55-2.017 7.773.864 8.329-.864 8.329-.865 10.549.865 7.774-.865 7.218-1.729 9.716-1.73 9.717-1.441h9.717l10.272-.865 7.218.865h4.164l6.941 1.441 8.051 2.594 8.328.865h3.054l6.941-3.459 7.218-1.441 6.385-.865 12.493-.864 4.164-2.018 9.162-.865 10.549-.864h4.442c1.758.288 5.386.864 5.83.864.444 0 6.108.577 8.884.865l7.218 2.018h8.606l8.329-2.018 5.83.865 11.105 1.153 6.94-1.153 11.938-.865c1.388-.288 4.275-.865 4.72-.865.444 0 3.516-.96 4.997-1.441h5.552l4.165-2.882h8.883l8.329-3.078M56 188.781l8.884-4.924 9.161-2.297 9.162 4.595 9.439-2.298h9.439l9.161-2.297h8.607l8.884-3.063 8.883 3.063 10.55-5.36 7.773 2.297 8.329-2.297 8.329-2.297 10.549 2.297 7.774-2.297 7.218-4.595 9.716-4.594 9.717-3.829h9.717l10.272-2.297 7.218 2.297h4.164l6.941 3.829 8.051 6.891 8.328 2.298h3.054l6.941-9.189 7.218-3.829 6.385-2.297 12.493-2.298 4.164-5.36 9.162-2.297 10.549-2.297h4.442c1.758.765 5.386 2.297 5.83 2.297.444 0 6.108 1.531 8.884 2.297l7.218 5.36h8.606l8.329-5.36 5.83 2.297 11.105 3.063 6.94-3.063 11.938-2.297c1.388-.766 4.275-2.297 4.72-2.297.444 0 3.516-2.553 4.997-3.829h5.552l4.165-7.657h8.883l8.329-8.178",
    stroke: "#AEAEAE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 120,
    width: 192,
    height: 192,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 140a76.01 76.01 0 0 1 53.74 22.26A76.009 76.009 0 0 1 488 216a76.01 76.01 0 0 1-22.26 53.74A76.009 76.009 0 0 1 412 292a76.01 76.01 0 0 1-53.74-22.26A75.993 75.993 0 0 1 336 216a76.006 76.006 0 0 1 22.26-53.74A75.993 75.993 0 0 1 412 140h0z",
    stroke: "#AEAEAE",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 140a75.998 75.998 0 0 1 67.784 110.37 75.999 75.999 0 1 1-124.529-84.927",
    stroke: "#777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 152a63.988 63.988 0 0 1 45.255 18.745A63.992 63.992 0 0 1 476 216a63.988 63.988 0 0 1-18.745 45.255A63.992 63.992 0 0 1 412 280a63.988 63.988 0 0 1-45.255-18.745A63.992 63.992 0 0 1 348 216a63.988 63.988 0 0 1 18.745-45.255A63.992 63.992 0 0 1 412 152h0z",
    stroke: "#AEAEAE",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 152a64.002 64.002 0 0 1 41.69 112.559 63.998 63.998 0 0 1-72.745 7.401 63.994 63.994 0 0 1-32.208-65.646",
    stroke: "#777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 164a52.006 52.006 0 0 1 36.77 15.23 52.006 52.006 0 0 1 0 73.54 52.006 52.006 0 0 1-73.54 0 52.006 52.006 0 0 1 0-73.54A52.006 52.006 0 0 1 412 164h0z",
    stroke: "#AEAEAE",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 164a51.999 51.999 0 0 1 27.032 96.421 51.992 51.992 0 0 1-51.564 1.429 51.991 51.991 0 0 1-19.511-18.206",
    stroke: "#777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 200,
    width: 72,
    height: 12,
    rx: 6,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391,
    y: 221,
    width: 42,
    height: 7,
    rx: 3.5,
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 504,
    height: 312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    in: "SourceAlpha",
    result: "effect1_dropShadow_201_86620"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0625882 0 0 0 0 0.0926346 0 0 0 0 0.15702 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_86620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_86620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 300,
    y: 104,
    width: 224,
    height: 224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_86620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_86620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 252,
    y1: 73.688,
    x2: 252,
    y2: 200.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F56D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRightImage);
export default __webpack_public_path__ + "static/media/login-right-image.0e6a25aa89a4110ae0579c2db5ca7691.svg";
export { ForwardRef as ReactComponent };